const getAnimationData = () => ({
  v: '5.5.9',
  fr: 60,
  ip: 0,
  op: 16,
  w: 64,
  h: 64,
  nm: 'Comp 1',
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Trash icon',
      sr: 1,
      ks: { p: { a: 0, k: [32, 32.5, 0] } },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, -0.83],
                    [0.77, -0.07],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.78, -0.09],
                    [0, 0],
                    [0, 0],
                    [0.19, 1.77],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.07, 0.77],
                    [0, 0],
                    [-0.77, 0.07],
                    [0, 0],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0.83, 0],
                    [0, 0.78],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.09, 1.8],
                    [0, 0],
                    [0, 0],
                    [-1.8, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.78, 0],
                    [0, 0],
                    [0, -0.78],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [-10.5, -12],
                    [10.5, -12],
                    [12, -10.5],
                    [10.64, -9.01],
                    [10.5, -9],
                    [9.48, -9],
                    [8.59, 8.67],
                    [5.29, 11.99],
                    [5.1, 12],
                    [-5.1, 12],
                    [-8.58, 8.87],
                    [-8.59, 8.67],
                    [-9.48, -9],
                    [-10.5, -9],
                    [-11.99, -10.36],
                    [-12, -10.5],
                    [-10.64, -11.99],
                    [-10.5, -12],
                    [10.5, -12],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ind: 1,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.23, -0.04],
                    [0, 0],
                    [0, 0],
                    [-0.05, 0.22],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [0, 0],
                    [0.01, 0.23],
                    [0, 0],
                    [0, 0],
                    [0.24, 0],
                    [0, 0],
                    [0, 0],
                  ],
                  v: [
                    [6.477, -9],
                    [-6.473, -9],
                    [-5.593, 8.53],
                    [-5.183, 8.99],
                    [-5.093, 9],
                    [5.097, 9],
                    [5.587, 8.61],
                    [5.597, 8.53],
                  ],
                  c: true,
                },
              },
              nm: 'Path 2',
              hd: false,
            },
            {
              ty: 'mm', mm: 1, nm: 'Merge Paths 1', hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [1, 0.149020001292, 0.149020001292, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Trash icon',
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 3600,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: 'Oval',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.333], y: [0] },
              t: 0,
              s: [0],
            },
            { t: 16, s: [100] },
          ],
        },
        p: { a: 0, k: [32, 32, 0] },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.833, 0.833, 0.833], y: [0.833, 0.833, 0.832] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [75, 75, 100],
            },
            { t: 16, s: [100, 100, 100] },
          ],
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [15.46, 0],
                    [0, -15.46],
                    [-15.46, 0],
                    [0, 15.46],
                  ],
                  o: [
                    [-15.46, 0],
                    [0, 15.46],
                    [15.46, 0],
                    [0, -15.46],
                  ],
                  v: [
                    [0, -28],
                    [-28, 0],
                    [0, 28],
                    [28, 0],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              hd: false,
            },
            {
              ind: 1,
              ty: 'sh',
              ks: {
                a: 0,
                k: {
                  i: [
                    [-13.81, 0],
                    [0, -13.81],
                    [13.81, 0],
                    [0, 13.81],
                  ],
                  o: [
                    [13.81, 0],
                    [0, 13.81],
                    [-13.81, 0],
                    [0, -13.81],
                  ],
                  v: [
                    [0, -25],
                    [25, 0],
                    [0, 25],
                    [-25, 0],
                  ],
                  c: true,
                },
              },
              nm: 'Path 2',
              hd: false,
            },
            {
              ty: 'mm', mm: 1, nm: 'Merge Paths 1', hd: false,
            },
            {
              ty: 'fl',
              c: { a: 0, k: [1, 0.149020001292, 0.149020001292, 1] },
              o: { a: 0, k: 100 },
              r: 1,
              bm: 0,
              nm: 'Fill 1',
              hd: false,
            },
            {
              ty: 'tr',
              p: { a: 0, k: [0, 0] },
              a: { a: 0, k: [0, 0] },
              s: { a: 0, k: [100, 100] },
              r: { a: 0, k: 0 },
              o: { a: 0, k: 100 },
              sk: { a: 0, k: 0 },
              sa: { a: 0, k: 0 },
              nm: 'Transform',
            },
          ],
          nm: 'Oval',
          bm: 0,
          hd: false,
        },
      ],
      ip: 0,
      op: 3600,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
});

export default getAnimationData;
